export const pages = {
  "about-us": {
    title: "About Us",
    content: `
      <div class="space-y-6">
        <p class="text-lg leading-relaxed">
        Hey there! We're <strong>Before Bots Takeover</strong>.
        </p>

        <p class="text-lg leading-relaxed">
        Since 2014, we've been building software for the Fortune 1,000,000 — the small businesses that
        keep our world thriving. We call our approach "noodle SaaS" – simple, practical
        solutions built with proven technologies like Ruby on Rails, and Vue.
        </p>

        <p class="text-lg leading-relaxed">
        Our name <strong>Before Bots Takeover</strong> reflects our core belief... no matter how far technology
        advances the human element remains the foundation of meaningful software.
        </p>

        <p class="text-lg leading-relaxed">
        In a world racing toward automation, we're committed to creating tools that enhance human capabilities
        rather than replace them. We build technology that works for people, not the other way around.
        </p>
      </div>
    `,
  },

  "our-ethos": {
    title: "Our Ethos",
    content: `
    <div class="space-y-6">
      <p class="text-lg leading-relaxed">
      In a world obsessed with AI disruption and enterprise solutions, we choose a different path.
      We believe software should amplify human potential, not replace it.
      </p>

      <p class="text-lg leading-relaxed">
      While others build for the Fortune 100, we create tools for the millions of small businesses
      that give our communities character.
      </p>

      <p class="text-lg leading-relaxed">
      Small businesses have been held hostage by tools they have to fit into. We believe it’s time
      to flip the script—when small businesses have tools built just for them, they can achieve extraordinary things.
      </p>

      <p class="text-lg leading-relaxed">
      <strong>We’re here to empower the dreamers, the doers, and the everyday heroes who pour their hearts into their work</strong>.
      </p>
    </div>
    `,
  },

  contacts: {
    title: "Contacts",
    content: `
      <div class="space-y-6">
        <p class="text-lg leading-relaxed">
          We love hearing from small business owners who are looking to make a big impact.
          Drop us a note and we'll get back to you within 24 hours.
          For ongoing communications expect replies within 15 minutes.
        </p>

        <p class="text-lg font-semibold underline decoration-black">
          <strong><a href="mailto:signal@beforebotstakeover.com">signal@beforebotstakeover.com</a></strong>
        </p>
      </div>
    `,
  },

  "terms-of-service": {
    title: "Terms of Service",
    content: `
      <div class="space-y-8">
        <header class="space-y-4">
          <h1 class="text-3xl font-bold">Terms of Service</h1>
          <p class="text-lg font-medium">Effective Date: January 15, 2025</p>
        </header>

        <div class="space-y-4">
          <p class="text-lg leading-relaxed">
            Welcome to <strong>Before Bots Takeover</strong> ("we," "us," or "our").
            These Terms of Service ("Terms") govern your use of our website (the "Site").
            By accessing or using the Site, you agree to comply with and be bound by these Terms.
            If you do not agree to these Terms, please do not use the Site.
          </p>
        </div>

        <section class="space-y-4">
          <h2 class="text-2xl font-bold">General Information</h2>
          <p class="text-lg leading-relaxed">
            Our Site, Before Bots Takeover (BBT), is a marketing website designed to provide
            information about our services and offerings. For any legal inquiries, please
            contact us at <strong>hello@beforebotstakeover.com</strong>.
          </p>
        </section>

        <section class="space-y-4">
          <h2 class="text-2xl font-bold">User Eligibility</h2>
          <p class="text-lg leading-relaxed">
            There are no age restrictions for using our Site. You do not need to create
            an account to access any features.
          </p>
        </section>

        <section class="space-y-4">
          <h2 class="text-2xl font-bold">User Responsibilities</h2>
          <p class="text-lg">By using our Site, you agree to the following rules:</p>
          <ul class="space-y-2 text-lg leading-relaxed list-disc pl-6">
            <li>Do not use the Site for any illegal or unauthorized purposes.</li>
            <li>Do not engage in spamming, harassment, or any activity that disrupts the Site.</li>
            <li>Do not scrape, copy, or reproduce any content from the Site without our prior
            written permission.</li>
          </ul>
          <p class="text-lg leading-relaxed">
            While we allow contact submissions, you are responsible for ensuring that any
            information you provide is accurate and lawful.
          </p>
        </section>

        <section class="space-y-4">
          <h2 class="text-2xl font-bold">Intellectual Property</h2>
          <p class="text-lg leading-relaxed">
            All content on the Site, including but not limited to text, images, videos, and
            logos, is owned by Before Bots Takeover and is protected by intellectual property
            laws. You may share our content with proper attribution, but any unauthorized use,
            reproduction, or distribution is strictly prohibited.
          </p>

          <div class="space-y-4">
            <h3 class="text-xl font-semibold">Copyright Infringement Claims</h3>
            <p class="text-lg leading-relaxed">
              We respect the intellectual property rights of others. If you believe that your
              work has been copied in a way that constitutes copyright infringement, please
              contact us at <strong>hello@beforebotstakeover.com</strong> with the following
              information:
            </p>
            <ul class="space-y-2 text-lg leading-relaxed list-disc pl-6">
              <li>A description of the copyrighted work you claim has been infringed.</li>
              <li>The location of the allegedly infringing material on the Site.</li>
              <li>Your contact information, including name, address, phone number, and email.</li>
              <li>A statement that you have a good faith belief that the use is not authorized
              by the copyright owner.</li>
              <li>A statement, made under penalty of perjury, that the information provided is
              accurate and that you are the copyright owner or authorized to act on their behalf.</li>
            </ul>
          </div>
        </section>

        <section class="space-y-4">
          <h2 class="text-2xl font-bold">Payments and Subscriptions</h2>
          <p class="text-lg leading-relaxed">
            We do not currently offer paid services, subscriptions, or products on our Site.
            However, if we do so in the future, we will use third-party payment processors
            like Stripe. Users will be subject to the terms and conditions of these processors.
          </p>
        </section>

        <section class="space-y-4">
          <h2 class="text-2xl font-bold">Disclaimers and Limitations of Liability</h2>
          <ul class="space-y-4 text-lg leading-relaxed list-disc pl-6">
            <li>
              <strong>Accuracy of Content:</strong> The information on this Site is for general
              purposes only and should not be considered professional advice. We do not guarantee
              the accuracy, completeness, or reliability of any content.
            </li>
            <li>
              <strong>Limitation of Liability:</strong> To the fullest extent permitted by law,
              we are not liable for any direct, indirect, incidental, consequential, or punitive
              damages arising from your use of the Site.
            </li>
            <li>
              <strong>Third-Party Links:</strong> The Site may contain links to third-party
              websites or services. We are not responsible for the content or practices of
              these third parties.
            </li>
          </ul>
        </section>

        <section class="space-y-4">
          <h2 class="text-2xl font-bold">Termination</h2>
          <p class="text-lg leading-relaxed">
            We reserve the right to terminate or suspend your access to the Site at any time,
            without notice, for any reason, including but not limited to violations of these
            Terms or illegal activities. You may terminate your relationship with us by
            unsubscribing from our communications.
          </p>
        </section>

        <section class="space-y-4">
          <h2 class="text-2xl font-bold">Governing Law and Dispute Resolution</h2>
          <p class="text-lg leading-relaxed">
            These Terms are governed by and construed in accordance with the laws of Canada.
            Any disputes arising from these Terms or your use of the Site will be resolved
            through binding arbitration in accordance with the rules of the Canadian Arbitration
            Association. The arbitration shall take place in Toronto, Ontario, and the decision
            of the arbitrator shall be final and binding.
          </p>
        </section>

        <section class="space-y-4">
          <h2 class="text-2xl font-bold">Updates to the Terms of Service</h2>
          <p class="text-lg leading-relaxed">
            We may update these Terms from time to time. If we make significant changes, we
            will notify you by email. Your continued use of the Site after such changes
            constitutes your acceptance of the updated Terms.
          </p>
        </section>

        <section class="space-y-4">
          <h2 class="text-2xl font-bold">Miscellaneous</h2>
          <ul class="space-y-4 text-lg leading-relaxed list-disc pl-6">
            <li>
              <strong>Force Majeure:</strong> We are not liable for any failure or delay in
              performance due to events beyond our reasonable control, including but not limited
              to acts of God, natural disasters, or government restrictions.
            </li>
            <li>
              <strong>Severability:</strong> If any provision of these Terms is found to be
              invalid or unenforceable, the remaining provisions will remain in full force
              and effect.
            </li>
          </ul>
        </section>

        <section class="space-y-4">
          <h2 class="text-2xl font-bold">Contact Us</h2>
          <p class="text-lg leading-relaxed">
            If you have any questions about these Terms, please contact us at:
            <br />
            <strong>Email:</strong> hello@beforebotstakeover.com
          </p>
        </section>
      </div>
    `,
  },

  "privacy-policy": {
    title: "Privacy Policy",
    content: `
      <div class="space-y-8">
        <header class="space-y-4">
          <h1 class="text-3xl font-bold">Privacy Policy</h1>
          <p class="text-lg font-medium">Effective Date: January 15, 2025</p>
        </header>

        <div class="space-y-4">
          <p class="text-lg leading-relaxed">
            Welcome to <strong>Before Bots Takeover</strong> ("we," "us," or "our").
            This Privacy Policy explains how we collect, use, disclose, and protect your
            personal information when you visit our website (the "Site").
            By using our Site, you agree to the terms of this Privacy Policy.
          </p>
        </div>

        <section class="space-y-4">
          <h2 class="text-2xl font-bold">Information We Collect</h2>
          <p class="text-lg">We collect the following types of personal information:</p>
          <ul class="space-y-4 text-lg leading-relaxed list-disc pl-6">
            <li>
              <strong>Information You Provide:</strong> When you sign up for our newsletter
              or contact us, we may collect your name and email address. If you email us,
              we may also collect your phone number.
            </li>
            <li>
              <strong>Automatically Collected Information:</strong> We use <strong>Cloudflare</strong>
              and <strong>Google Analytics</strong> to collect data such as your IP address,
              browser type, and browsing behavior. This data is not stored on our servers.
            </li>
          </ul>
          <p class="text-lg">
            We do not collect sensitive data (e.g., health information, financial data, or
            government IDs) or data from third parties.
          </p>
        </section>

        <section class="space-y-4">
          <h2 class="text-2xl font-bold">How We Use Your Information</h2>
          <p class="text-lg">We use your personal information for the following purposes:</p>
          <ul class="space-y-2 text-lg leading-relaxed list-disc pl-6">
            <li>To send you marketing emails and newsletters.</li>
            <li>To improve your experience on our Site.</li>
          </ul>
          <p class="text-lg">We do not use your data for advertising purposes.</p>
        </section>

        <section class="space-y-4">
          <h2 class="text-2xl font-bold">Sharing Your Information</h2>
          <p class="text-lg">We may share your information with the following third parties:</p>
          <ul class="space-y-2 text-lg leading-relaxed list-disc pl-6">
            <li><strong>Cloudflare:</strong> For website performance and security.</li>
            <li><strong>Google Analytics:</strong> For analyzing website traffic and usage.</li>
            <li><strong>Stripe:</strong> For processing payments (if applicable).</li>
          </ul>
          <p class="text-lg">We do not sell or rent your personal information to third parties.</p>
        </section>

        <section class="space-y-4">
          <h2 class="text-2xl font-bold">Data Storage and Security</h2>
          <p class="text-lg">Your data is stored on <strong>Fly.io</strong> cloud services.
          We take reasonable measures to protect your information, including:</p>
          <ul class="space-y-2 text-lg leading-relaxed list-disc pl-6">
            <li>Encryption of data in transit and at rest.</li>
            <li>Access controls to limit who can access your data.</li>
            <li>Cloudflare's CDN for additional security.</li>
          </ul>
          <p class="text-lg">
            We retain your data for <strong>180 days</strong> unless you are in active
            communication with us, in which case we may retain it longer.
          </p>
        </section>

        <section class="space-y-4">
          <h2 class="text-2xl font-bold">Your Rights</h2>
          <p class="text-lg">
            While users cannot create profiles or submit sensitive information on our Site,
            you have the following rights:
          </p>
          <ul class="space-y-4 text-lg leading-relaxed list-disc pl-6">
            <li>
              <strong>Opt-Out:</strong> You can unsubscribe from our marketing communications
              at any time by clicking the "unsubscribe" link in our emails.
            </li>
            <li>
              <strong>Compliance:</strong> We comply with <strong>GDPR</strong> and
              <strong>CCPA</strong> regulations.
            </li>
          </ul>
          <p class="text-lg">
            If you have questions about your data, please contact us at
            <strong>privacy@beforebotstakeover.com</strong>.
          </p>
        </section>

        <section class="space-y-4">
          <h2 class="text-2xl font-bold">Cookies and Tracking Technologies</h2>
          <p class="text-lg">We use cookies and similar technologies for:</p>
          <ul class="space-y-2 text-lg leading-relaxed list-disc pl-6">
            <li><strong>Analytics:</strong> To understand how users interact with our Site.</li>
            <li><strong>Functionality:</strong> To ensure the Site operates correctly.</li>
          </ul>
          <p class="text-lg">You can manage or disable cookies through your browser settings.</p>
        </section>

        <section class="space-y-4">
          <h2 class="text-2xl font-bold">Children's Privacy</h2>
          <p class="text-lg">
            Our Site is not intended for children under 13 (or 16 in some regions). We do not
            knowingly collect or store information from minors.
          </p>
        </section>

        <section class="space-y-4">
          <h2 class="text-2xl font-bold">International Users</h2>
          <p class="text-lg">
            We welcome users from outside Canada. However, we only comply with
            <strong>Canadian data protection laws</strong>. If you are located in a region
            with stricter laws (e.g., GDPR), please contact us for additional information.
          </p>
        </section>

        <section class="space-y-4">
          <h2 class="text-2xl font-bold">Updates to This Privacy Policy</h2>
          <p class="text-lg">
            We may update this Privacy Policy from time to time. If we make significant
            changes, we will notify you by email.
          </p>
        </section>

        <section class="space-y-4">
          <h2 class="text-2xl font-bold">Contact Us</h2>
          <p class="text-lg">
            If you have any questions about this Privacy Policy or your data, please
            contact us at: <strong>privacy@beforebotstakeover.com</strong>
          </p>
        </section>
      </div>
    `,
  },

  copyright: {
    title: "Copyright",
    content: `
      <div class="space-y-4">
        <h1 class="text-lg font-bold">Copyright Notice</h1>
        <p class="text-lg">© 2025 Before Bots Takeover</p>
      </div>
    `,
  },

  "icon": {
    title: "BBT Icon",
    content: `
      <div class="space-y-6">
        <div class="flex justify-center">
          <img 
            src="/BBT_icon.png" 
            alt="Before Bots Takeover Icon" 
            class="max-w-full h-auto"
          />
        </div>
      </div>
    `
  },

  "bbt-logo": {
    title: "BBT Logo",
    content: `
      <div class="space-y-6">
        <div class="flex justify-center">
          <img 
            src="/BBT_logo.png" 
            alt="Before Bots Takeover Logo" 
            class="max-w-full h-auto"
          />
        </div>
      </div>
    `
  },
};
